define('type/flow/Serum.Flow',[
  'jquery',
  'common/js/lib/Serum.Pubsub',
  'common/module/asset/Serum.Asset.Fragment'
], function($, Pubsub, Fragment) {
  'use strict';

  /** @constructor */
  function PaginatedFlow($container) {

    /** @private */
    var isLoading = false;

    function appendFlowContent($content, $button) {

      $content.appendTo($container.find('.flow-content'));

      var nextID = $container.find('.next-data-id').remove().val();
      if (nextID) {
        $button.attr('data-id', nextID);
      }

      setTimeout(function() {
        if (nextID) {
          $button.parent().show();
          $button.removeClass('is-busy');
        } else {
          $container.off('click', '.flow-page-forward', onPageForwards);
          $button.parent().hide();
        }

      }, 1000);

      Pubsub.publish(Pubsub.topics.CONTENT_RELOAD, $container);
    }

    function onPageForwards(e) {

      if(isLoading) {
        return;
      }

      e.preventDefault();
      var $button = $(this);

      $button.addClass('is-busy');
      isLoading = true;
      Fragment.render($button.attr('data-id'), null, null, {
        onUpdate : function($content) {
          isLoading = false;
          appendFlowContent($content, $button);

          Pubsub.publish(Pubsub.topics.CHECK_FOR_NRKNO_EMBED);
          Pubsub.publish(Pubsub.topics.TRACK_EVENT, {
            category : 'Flow',
            action : 'Vis flere'
          });
        }
      });
    }

    function setupEvents() {
      $container.on('click', '.flow-page-forward', onPageForwards);
    }

    function initialize() {
      setupEvents();
    }

    initialize();
  }

  /** @public */
  PaginatedFlow.bootstrap = function($elements) {
    $elements.each(function() {
      new PaginatedFlow($(this)); // eslint-disable-line no-new
    });
  };

  /** @interface */
  return PaginatedFlow;
});

